!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.or = t());
}(this, function () {
  "use strict";

  return [{
    locale: "or",
    pluralRuleFunction: function pluralRuleFunction(e, t) {
      var r = String(e).split("."),
          o = Number(r[0]) == e;
      return t ? 1 == e || 5 == e || o && e >= 7 && e <= 9 ? "one" : 2 == e || 3 == e ? "two" : 4 == e ? "few" : 6 == e ? "many" : "other" : 1 == e ? "one" : "other";
    },
    fields: {
      year: {
        displayName: "ବର୍ଷ",
        relative: {
          0: "ଏହି ବର୍ଷ",
          1: "ଆଗାମୀ ବର୍ଷ",
          "-1": "ଗତ ବର୍ଷ"
        },
        relativeTime: {
          future: {
            one: "{0} ବର୍ଷରେ",
            other: "{0} ବର୍ଷରେ"
          },
          past: {
            one: "{0} ବର୍ଷ ପୂର୍ବେ",
            other: "{0} ବର୍ଷ ପୂର୍ବେ"
          }
        }
      },
      "year-short": {
        displayName: "ବ.",
        relative: {
          0: "ଏହି ବର୍ଷ",
          1: "ଆଗାମୀ ବର୍ଷ",
          "-1": "ଗତ ବର୍ଷ"
        },
        relativeTime: {
          future: {
            one: "{0} ବ. ରେ",
            other: "{0} ବ. ରେ"
          },
          past: {
            one: "{0} ବ. ପୂର୍ବେ",
            other: "{0} ବ. ପୂର୍ବେ"
          }
        }
      },
      month: {
        displayName: "ମାସ",
        relative: {
          0: "ଏହି ମାସ",
          1: "ଆଗାମୀ ମାସ",
          "-1": "ଗତ ମାସ"
        },
        relativeTime: {
          future: {
            one: "{0} ମାସରେ",
            other: "{0} ମାସରେ"
          },
          past: {
            one: "{0} ମାସ ପୂର୍ବେ",
            other: "{0} ମାସ ପୂର୍ବେ"
          }
        }
      },
      "month-short": {
        displayName: "ମା.",
        relative: {
          0: "ଏହି ମାସ",
          1: "ଆଗାମୀ ମାସ",
          "-1": "ଗତ ମାସ"
        },
        relativeTime: {
          future: {
            one: "{0} ମା. ରେ",
            other: "{0} ମା. ରେ"
          },
          past: {
            one: "{0} ମା. ପୂର୍ବେ",
            other: "{0} ମା. ପୂର୍ବେ"
          }
        }
      },
      day: {
        displayName: "ଦିନ",
        relative: {
          0: "ଆଜି",
          1: "ଆସନ୍ତାକାଲି",
          "-1": "ଗତକାଲି"
        },
        relativeTime: {
          future: {
            one: "{0} ଦିନରେ",
            other: "{0} ଦିନରେ"
          },
          past: {
            one: "{0} ଦିନ ପୂର୍ବେ",
            other: "{0} ଦିନ ପୂର୍ବେ"
          }
        }
      },
      "day-short": {
        displayName: "ଦିନ",
        relative: {
          0: "ଆଜି",
          1: "ଆସନ୍ତାକାଲି",
          "-1": "ଗତକାଲି"
        },
        relativeTime: {
          future: {
            one: "{0} ଦିନରେ",
            other: "{0} ଦିନରେ"
          },
          past: {
            one: "{0} ଦିନ ପୂର୍ବେ",
            other: "{0} ଦିନ ପୂର୍ବେ"
          }
        }
      },
      hour: {
        displayName: "ଘଣ୍ଟା",
        relative: {
          0: "ଏହି ଘଣ୍ଟା"
        },
        relativeTime: {
          future: {
            one: "{0} ଘଣ୍ଟାରେ",
            other: "{0} ଘଣ୍ଟାରେ"
          },
          past: {
            one: "{0} ଘଣ୍ଟା ପୂର୍ବେ",
            other: "{0} ଘଣ୍ଟା ପୂର୍ବେ"
          }
        }
      },
      "hour-short": {
        displayName: "ଘ.",
        relative: {
          0: "ଏହି ଘଣ୍ଟା"
        },
        relativeTime: {
          future: {
            one: "{0} ଘ. ରେ",
            other: "{0} ଘ. ରେ"
          },
          past: {
            one: "{0} ଘ. ପୂର୍ବେ",
            other: "{0} ଘ. ପୂର୍ବେ"
          }
        }
      },
      minute: {
        displayName: "ମିନିଟ୍",
        relative: {
          0: "ଏହି ମିନିଟ୍"
        },
        relativeTime: {
          future: {
            one: "{0} ମିନିଟ୍‌‌ରେ",
            other: "{0} ମିନିଟ୍‌‌ରେ"
          },
          past: {
            one: "{0} ମିନିଟ୍ ପୂର୍ବେ",
            other: "{0} ମିନିଟ୍ ପୂର୍ବେ"
          }
        }
      },
      "minute-short": {
        displayName: "ମି.",
        relative: {
          0: "ଏହି ମିନିଟ୍"
        },
        relativeTime: {
          future: {
            one: "{0} ମି. ରେ",
            other: "{0} ମି. ରେ"
          },
          past: {
            one: "{0} ମି. ପୂର୍ବେ",
            other: "{0} ମି. ପୂର୍ବେ"
          }
        }
      },
      second: {
        displayName: "ସେକେଣ୍ଡ୍",
        relative: {
          0: "ବର୍ତ୍ତମାନ"
        },
        relativeTime: {
          future: {
            one: "{0} ସେକେଣ୍ଡରେ",
            other: "{0} ସେକେଣ୍ଡରେ"
          },
          past: {
            one: "{0} ସେକେଣ୍ଡ ପୂର୍ବେ",
            other: "{0} ସେକେଣ୍ଡ ପୂର୍ବେ"
          }
        }
      },
      "second-short": {
        displayName: "ସେକେଣ୍ଡ୍",
        relative: {
          0: "ବର୍ତ୍ତମାନ"
        },
        relativeTime: {
          future: {
            one: "{0} ସେ. ରେ",
            other: "{0} ସେ. ରେ"
          },
          past: {
            one: "{0} ସେ. ପୂର୍ବେ",
            other: "{0} ସେ. ପୂର୍ବେ"
          }
        }
      }
    }
  }];
});